<template>
    <div class="lp-location-finder-list__locations" v-if="visibleLocations.length > 0">
      <div v-for="(location, index) in visibleLocations">
        <location-list-item :location="location"
                            :index="index"
                            :details-url="detailsUrl"
                            :enable-details="enableDetails"
                            :center="center"
                            :filter-by-distance-flag="filterByDistanceFlag" />

        <hr v-show="!(index == visibleLocations.length - 1)" class="text-dark my-5 me-5" />
      </div>
    </div>
    <p v-else class="h4">No locations match the current filter.</p>
</template>
<script>
    import LocationListItem from "./LocationListItem.vue";

    export default {
        components: { LocationListItem },
        name: 'LocationList',
        props: {
            visibleLocations: {
                type: Array,
                required: true
            },
            detailsUrl: {
                type: String,
                required: true
            },
            enableDetails: {
                type: Boolean,
                required: true
            },
            center: {
              type: Object,
              required: false
            },
            filterByDistanceFlag: {
              type: Boolean,
              required: false,
              default: false
            }
        },
        setup: (props) => {
        }
    }
</script>

<style lang="scss" scoped></style>
